import { magellanClient } from '../../../infra/axios';
import type {
  CreateWorkspaceUserDTO,
  GetWorkspaceUsersResponseDTO,
  UpdateWorkspaceUserDTO,
} from './dto';

export async function createWorkspaceUser({
  workspaceId,
  payload,
}: {
  workspaceId: number;
  payload: CreateWorkspaceUserDTO;
}) {
  await magellanClient.post(`/workspaces/${workspaceId}/users`, payload);
}

export async function getWorkspaceUsers(workspaceId: number) {
  const response = await magellanClient.get<GetWorkspaceUsersResponseDTO>(
    `/workspaces/${workspaceId}/users`,
  );

  return response.data;
}

export async function updateWorkspaceUser({
  userId,
  workspaceId,
  payload,
}: {
  userId: number;
  workspaceId: number;
  payload: UpdateWorkspaceUserDTO;
}) {
  await magellanClient.put(
    `/workspaces/${workspaceId}/users/${userId}`,
    payload,
  );
}
